import { Mapper } from "../../../../base/utils/mapper";
import { CanalModel } from "../../../../domain/models/configuration/canal.model";
import { CanalEntity } from "../entities/canal.entity";

export class CanalImplementationRepositoryMapper extends Mapper<CanalEntity, CanalModel> {
    mapFrom(param: CanalEntity): CanalModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: CanalModel): CanalEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}